export default __webpack_public_path__ + "static/media/alpha2.cbf9c660.png";